export default __webpack_public_path__ + "static/media/control-foto4.4c12304e.jpg";